<template>
  <div class="great-animation app-size">
    <img
      src="../assets/img/animations/great.gif"
      v-if="ninjaStatus === 'talk'"
      alt=""
    />
    <img
      src="../assets/img/ninja_corner/corner_down.gif"
      v-if="ninjaStatus === 'down'"
      alt=""
    />
    <img
      src="../assets/img/ninja_corner/corner_up.gif"
      @load="startAnimation()"
      v-if="ninjaStatus === 'up'"
      alt=""
    />
    <img
      src="../assets/img/ninja_corner/corner_talk.gif"
      v-if="ninjaStatus === 'talk'"
      alt=""
    />
    <audio ref="greatSounds" @ended="endAnimation">
      <source src="../assets/sound/great.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
export default {
  name: 'GreatAnimation',
  data() {
    return {
      ninjaStatus: null
    };
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    startAnimation() {
      this.ninjaStatus = 'up';
      setTimeout(() => {
        this.ninjaStatus = 'talk';
        this.$refs.greatSounds.play();
      }, 500);
    },
    endAnimation() {
      this.ninjaStatus = 'down';
      setTimeout(() => {
        this.$emit('endGreat', true);
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
}
</style>
